// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__1ymhI","image":"styles_image__eL5g5","number":"styles_number__aWecf","title":"styles_title__8Wa6a"};